import { render, staticRenderFns } from "./MYP301P01.vue?vue&type=template&id=a66954d4&"
import script from "./MYP301P01.vue?vue&type=script&lang=js&"
export * from "./MYP301P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports